<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path d="M14.2,8.6h-2.5v-2.5h1.2c.7,0,1.2-.6,1.2-1.2V1.2C14.2.6,13.6,0,12.9,0H3.1C2.4,0,1.8.6,1.8,1.2v3.7c0,.7.6,1.2,1.2,1.2h1.2v2.5H1.8c-.7,0-1.2.6-1.2,1.2v1.2c0,.7.6,1.2,1.2,1.2h.6v3.1c0,.3.3.6.6.6s.6-.3.6-.6v-3.1h8.6v3.1c0,.3.3.6.6.6s.6-.3.6-.6v-3.1h.6c.7,0,1.2-.6,1.2-1.2v-1.2c0-.7-.6-1.2-1.2-1.2M3.1,1.2h9.8v3.7H3.1V1.2ZM5.5,6.2h4.9v2.5h-4.9v-2.5ZM14.2,11.1H1.8v-1.2h12.3v1.2Z"/>
  </svg>
</template>
